import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './FeelingTag.css';
import { FaTimes } from 'react-icons/fa';

const FeelingTag = ({ feeling, onRemove }) => {
  if (!feeling) return null;

  return (
    <div className="ft-container">
      <span className="ft-emoji">{feeling.icon}</span>
      <span className="ft-text">
        Se sent {feeling.label}
      </span>
      <div 
        className="ft-remove" 
        onClick={onRemove}
        title="Retirer le sentiment"
      >
        <FaTimes size={12} />
      </div>
    </div>
  );
};

export default FeelingTag;
export {FeelingTag};